var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8727_74647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.677 138.349C135.163 136.048 155.889 128.963 155.889 95.3055C155.889 85.7391 152.52 77.943 147.033 71.9191C147.918 69.6184 150.75 60.9371 145.965 48.893C145.965 48.893 138.88 46.5891 122.231 57.748C115.146 55.8016 107.352 54.5594 100.09 54.5594C92.6473 54.5594 84.8512 55.8016 77.9426 57.748C61.1137 46.5891 54.0285 48.893 54.0285 48.893C49.2469 60.9371 52.082 69.6184 52.9668 71.9191C47.4742 77.9426 44.1086 85.7391 44.1086 95.3055C44.1086 128.963 64.834 136.048 84.3203 138.349C81.8422 140.479 79.5387 144.55 78.6535 150.219C73.6918 152.343 60.7598 156.42 52.9668 142.957C52.9668 142.957 48.3594 134.632 39.6809 134.102C39.6809 134.102 30.9996 133.925 38.9727 139.411C38.9727 139.411 44.8164 142.072 48.716 152.166C48.716 152.166 54.0285 168.998 78.4734 163.682V178.737C78.4734 181.045 76.7039 183.699 72.2762 182.991C37.5543 171.475 12.5781 138.526 12.5781 99.9102C12.5781 51.548 51.725 12.4016 100.09 12.4016C148.272 12.4016 187.599 51.5484 187.422 99.9102C187.422 138.526 162.443 171.298 127.723 182.991C123.293 183.877 121.523 181.222 121.523 178.737V154.473C121.523 146.319 118.862 141.01 115.677 138.349ZM200 100.09C200 44.8164 155.181 0 100.09 0C44.8164 0 0 44.8164 0 100.09C0 155.181 44.8164 200 100.09 200C155.181 200 200 155.181 200 100.09Z",
    fill: "#090A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8727_74647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github_icon.3778363909df10ad8b5bb9405f7c1fbe.svg";
export { ForwardRef as ReactComponent };